import { defaultLightTheme } from '../default/default';
const b2bButton = '#081F57';
const b2bBackground = '#002FA7';
const b2bButtonHover = '#394B78';
export const b2bTheme = {
    ...defaultLightTheme,
    color: {
        ...defaultLightTheme.color,
        button: {
            ...defaultLightTheme.color.button,
            primary: {
                ...defaultLightTheme.color.button.primary,
                fill: {
                    on: {
                        background: b2bButton,
                    },
                },
                border: {
                    on: {
                        background: b2bButton,
                    },
                },
                hover: {
                    ...defaultLightTheme.color.button.primary.hover,
                    fill: {
                        on: {
                            background: b2bButtonHover,
                        },
                    },
                    border: {
                        on: {
                            background: b2bButtonHover,
                        },
                    },
                },
            },
        },
        fill: {
            ...defaultLightTheme.color.fill,
            strong: b2bBackground,
        },
    },
    name: 'b2b',
};
//# sourceMappingURL=index.js.map